// extracted by mini-css-extract-plugin
export default {"articlesBlock":"Paper_articlesBlock__tevpz","articles":"Paper_articles__0O3fX","article":"Paper_article__77os8"};